import styled from "@emotion/styled"
import { css } from "@emotion/react"

const dynamicStyle = ({ theme, active, showIndicator }) => css`
  ${active &&
  `
  ${theme.breakpoints.down("xl")} {
    transition: 0.3s;
    background: #F8F8FB;
    box-shadow: -10px 10px 40px rgba(118, 118, 129, 0.07);
    border-bottom: 1px solid #EDEDF8;}`}

  ${showIndicator &&
  `
  ${theme.breakpoints.up("xl")} {

   &:hover > button {
      &::after {
        opacity: 1;
        pointer-events: all;
      }
    }
  }`}
`

const HeaderNavItemWrapper = styled.div`
  display: flex;
  pointer-events: ${(props) => (props.didHydrate ? "auto" : "none")};
  ${({ theme }) => theme.breakpoints.down("xl")} {
    flex-direction: column;
    border-bottom: transparent;
    &:first-of-type {
      padding-top: 15px;
    }
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    &:hover .header-nav-sublist {
      max-height: 700px;
    }
  }

  ${({ theme }) => theme.breakpoints.between("sm", "xl")} {
    padding-top: ${({ isScrollingUp }) => `${isScrollingUp ? 8 : 4}px`};
    padding-bottom: ${({ isScrollingUp }) => `${isScrollingUp ? 8 : 4}px`};
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    padding-top: ${({ isScrollingUp }) => `${isScrollingUp ? 20 : 10}px`};
    padding-bottom: ${({ isScrollingUp }) => `${isScrollingUp ? 20 : 10}px`};
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    padding-top: ${({ isScrollingUp }) => `${isScrollingUp ? 20 : 10}px`};
    padding-bottom: ${({ isScrollingUp }) => `${isScrollingUp ? 20 : 10}px`};
  }

  ${dynamicStyle}
`

export default HeaderNavItemWrapper
